import { useState } from "react";
import axios from "axios";
import { PageTitle } from "./PageTitle";
import { validateEmail } from "../helpers/helpers";

export const ContactForm = ({ projectTitle }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [isValidEmail, setIsValidEmail] = useState(false);

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const title = projectTitle || "Unknown Project";

  const handleEmailChange = (event) => {
    const { value } = event.target;
    setEmail(value);
    setIsValidEmail(validateEmail(value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidEmail) {
      setError("Please enter a valid email address.");
      setSubmitted(false);
      setEmail("");
      return;
    }

    // Use your single formcarry endpoint
    const formcarryEndpoint = "https://formcarry.com/s/-xYfevi8i8D";

    try {
      // Add the project info to the form submission
      await axios.post(formcarryEndpoint, {
        name: name,
        email: email,
        // Prepend the project title to the message
        message: `[Message from ${title} website]\n\n${message}`,
        // Also send as a separate field in case you want to filter by it
        project: title,
      });
      setSubmitted(true);
    } catch (error) {
      setError(
        "An error occurred while submitting the form. Please try again later."
      );
      console.error("Error submitting form:", error);
    }
  };

  if (submitted) {
    return <p style={{ color: "white" }}>Thank you for contacting me!</p>;
  }

  return (
    <form onSubmit={handleSubmit} className="contact-form shadow-img">
      <PageTitle pageTitle={`CONTACT ${projectTitle}`} />
      {error && <p style={{ color: "white" }}>{error}</p>}
      <input
        id="name"
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
        placeholder="Your name"
        autoComplete="name"
      />
      <input
        id="email"
        type="email"
        value={email}
        onChange={handleEmailChange}
        required
        placeholder="Your e-mail"
        autoComplete="email"
      />
      <textarea
        id="message"
        value={message}
        required
        onChange={(e) => {
          setMessage(e.target.value);
          e.target.style.height = "auto";
          e.target.style.height = e.target.scrollHeight + "px";
        }}
        placeholder="Message"
      />

      <button type="submit" className="subscribe-btn shadow-img">
        <div className="subscribe-btn-text">SUBMIT</div>
      </button>
    </form>
  );
};
